import styles from "./adminIndex.module.css";

const numberFormat = new Intl.NumberFormat("en-US");

// Tab text with a quiet count after it, e.g. "Waiting 11,578".
export default function TabLabel({ label, count }) {
  return (
    <span>
      {label}
      <span className={styles.count}>{numberFormat.format(Number(count) || 0)}</span>
    </span>
  );
}
